import React from 'react';

const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

interface PlanningDayHeaderProps {
  dateKey: string; // "YYYY-MM-DD"
  eventCount: number;
}

/**
 * PlanningDayHeader — "Monday 3 March (3 events)"
 */
const PlanningDayHeader: React.FC<PlanningDayHeaderProps> = ({ dateKey, eventCount }) => {
  const date = new Date(dateKey + 'T00:00:00');
  const dayName = DAY_NAMES[date.getDay()];
  const dayNum = date.getDate();
  const month = MONTH_NAMES[date.getMonth()];

  return (
    <div className="planning-day-header">
      <span className="planning-day-header__label">
        {dayName} {dayNum} {month}
      </span>
      {eventCount > 0 && (
        <span className="planning-day-header__count">
          ({eventCount} {eventCount === 1 ? 'event' : 'events'})
        </span>
      )}
      <span className="planning-day-header__line" />
    </div>
  );
};

export default React.memo(PlanningDayHeader);
